import React, { createContext, useContext, useEffect } from "react"
import { useMap } from "react-leaflet"

// True while the user is placing voyage-planner points on the map: GIS layers
// then go non-interactive so a click sets the point instead of opening a popup.
const GisSuppressedContext = createContext(false)

// Markers with GIS_MARKER_CLASS let clicks through to the map while the container has this class,
// so layers need not rebuild their markers to switch interactivity.
export const GIS_MARKER_CLASS = "gis-marker"
const GIS_SUPPRESSED_CLASS = "gis-suppressed"

export function GisInteractivityProvider({ suppressed, children }) {
  const map = useMap()
  useEffect(() => {
    const container = map.getContainer()
    container.classList.toggle(GIS_SUPPRESSED_CLASS, !!suppressed)
    return () => container.classList.remove(GIS_SUPPRESSED_CLASS)
  }, [map, suppressed])
  return (
    <GisSuppressedContext.Provider value={suppressed}>
      {children}
    </GisSuppressedContext.Provider>
  )
}

export function useGisSuppressed() {
  return useContext(GisSuppressedContext)
}
